export default class UserEventsIncoming {
  public static readonly SET_LIST = "USER_EVENTS_INCOMING_SET_LIST";
  public static readonly SET_COUNTER = "USER_EVENTS_INCOMING_SET_COUNTER";
  public static readonly SET_STATUS = "USER_EVENTS_INCOMING_SET_STATUS";
  public static readonly SET_ERROR = "USER_EVENTS_INCOMING_SET_ERROR";
  public static readonly CLEAR = "USER_EVENTS_INCOMING_CLEAR";

  public static setList(data: any) {
    return {
      data,
      type: UserEventsIncoming.SET_LIST,
    };
  }

  public static setCounter(data: any) {
    return {
      data,
      type: UserEventsIncoming.SET_COUNTER,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: UserEventsIncoming.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: UserEventsIncoming.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: UserEventsIncoming.CLEAR,
    };
  }
}
